import { getActionTypes } from '../../../HelperMethods/UtilityFunctions';
import { updateNormalizedTaskProperties } from '../../../HelperMethods/TaskUtilities';

const types = getActionTypes('approvalMatrixManagement')([
  'SET_LOADER',
  'LOAD_APPROVAL_REQUESTS',
  'LOAD_WORK_REQUESTS',
  'DELETE_WORK_REQUEST',
  'DELETE_APPROVAL_REQUEST',
  'UPSERT_APPROVAL_REQUEST',
  'UPSERT_WORK_REQUEST',
  'UPDATE_APPROVAL_REQUESTS',
  'UPDATE_WORK_REQUESTS',
  'SET_VIEW',
  'CLEAR_VIEW',
]);
export function setView(view) {
  return { type: types.SET_VIEW, view };
}
export function clearView() {
  return { type: types.CLEAR_VIEW };
}

export function loadApprovalRequests(approvalRequests) {
  return { type: types.LOAD_APPROVAL_REQUESTS, approvalRequests };
}

export function loadWorkRequests(workRequests) {
  return { type: types.LOAD_WORK_REQUESTS, workRequests };
}

export function setLoader(loader) {
  return { type: types.SET_LOADER, loader };
}

export function deleteWorkRequest(id) {
  return { type: types.DELETE_WORK_REQUEST, id };
}

export function deleteApprovalRequest(id) {
  return { type: types.DELETE_APPROVAL_REQUEST, id };
}

export function upsertWorkRequest({ workRequest, picklistOptions, tenantId, stopForSelectedAsset }) {
  return { type: types.UPSERT_WORK_REQUEST, workRequest, picklistOptions, tenantId, stopForSelectedAsset };
}
export function upsertApprovalRequest({ approvalRequest, picklistOptions, tenantId, stopForSelectedAsset }) {
  return { type: types.UPSERT_APPROVAL_REQUEST, approvalRequest, picklistOptions, tenantId, stopForSelectedAsset };
}

export function updateWorkRequests(updatedWorkRequests, deletedWorkRequests) {
  return { type: types.UPDATE_WORK_REQUESTS, updatedWorkRequests, deletedWorkRequests };
}
export function updateApprovalRequests(updatedApprovalRequests, deletedApprovalRequests) {
  return { type: types.UPDATE_APPROVAL_REQUESTS, updatedApprovalRequests, deletedApprovalRequests };
}

export default function approvalTasksReducer(
  state = {
    isLoading: false,
    approvalRequests: [],
    workRequests: [],
    view: '',
  },
  action
) {
  switch (action.type) {
    case types.SET_VIEW: {
      const { view } = action;
      return { ...state, view };
    }
    case types.CLEAR_VIEW: {
      return { ...state, view: '' };
    }
    case types.SET_LOADER: {
      return { ...state, isLoading: action.loader };
    }
    case types.LOAD_APPROVAL_REQUESTS: {
      return { ...state, approvalRequests: action.approvalRequests };
    }
    case types.LOAD_WORK_REQUESTS: {
      return { ...state, workRequests: action.workRequests };
    }
    case types.DELETE_WORK_REQUEST: {
      return {
        ...state,
        workRequests: state.workRequests.filter(({ id }) => id !== action.id),
      };
    }
    case types.DELETE_APPROVAL_REQUEST: {
      return {
        ...state,
        approvalRequests: state.approvalRequests.filter(({ id }) => id !== action.id),
      };
    }
    case types.UPSERT_APPROVAL_REQUEST: {
      const { approvalRequest, picklistOptions, tenantId, stopForSelectedAsset } = action;
      const oldApprovalRequest = state.approvalRequests.find((t) => t.id === approvalRequest.id);
      const normalizedTask = updateNormalizedTaskProperties(
        approvalRequest,
        oldApprovalRequest,
        picklistOptions,
        tenantId,
        stopForSelectedAsset
      );
      return {
        ...state,
        approvalRequests: [...state.approvalRequests.filter(({ id }) => id !== approvalRequest.id), normalizedTask],
        isLoading: false,
      };
    }
    case types.UPSERT_WORK_REQUEST: {
      const { workRequest, picklistOptions, tenantId, stopForSelectedAsset } = action;
      const oldWorkRequest = state.workRequests.find((t) => t.id === workRequest.id);
      const normalizedTask = updateNormalizedTaskProperties(
        workRequest,
        oldWorkRequest,
        picklistOptions,
        tenantId,
        stopForSelectedAsset
      );
      return {
        ...state,
        workRequests: [...state.workRequests.filter(({ id }) => id !== workRequest.id), normalizedTask],
        isLoading: false,
      };
    }
    case types.UPDATE_APPROVAL_REQUESTS: {
      const { updatedApprovalRequests, deletedApprovalRequests } = action;
      const updatedApprovalRequestsIds = new Set(updatedApprovalRequests.map((val) => val.id));
      const deletedApprovalRequestsIds = new Set(deletedApprovalRequests.map((val) => val.id));
      let filteredApprovalRequests = state.approvalRequests.filter(({ id }) => !updatedApprovalRequestsIds.has(id));
      filteredApprovalRequests = filteredApprovalRequests.filter(({ id }) => !deletedApprovalRequestsIds.has(id));
      return {
        ...state,
        approvalRequests: [...filteredApprovalRequests, ...updatedApprovalRequests],
        isLoading: false,
      };
    }
    case types.UPDATE_WORK_REQUESTS: {
      const { updatedWorkRequests, deletedWorkRequests } = action;
      const updatedWorkRequestsIds = new Set(updatedWorkRequests.map((val) => val.id));
      const deletedWorkRequestsIds = new Set(deletedWorkRequests.map((val) => val.id));
      let filteredWorkRequests = state.workRequests.filter(({ id }) => !updatedWorkRequestsIds.has(id));
      filteredWorkRequests = filteredWorkRequests.filter(({ id }) => !deletedWorkRequestsIds.has(id));
      return {
        ...state,
        workRequests: [...filteredWorkRequests, ...updatedWorkRequests],
        isLoading: false,
      };
    }
    default:
      return state;
  }
}
